import { render, staticRenderFns } from "./ReLogin.vue?vue&type=template&id=18b1a4f2&scoped=true&"
import script from "./ReLogin.vue?vue&type=script&lang=js&"
export * from "./ReLogin.vue?vue&type=script&lang=js&"
import style0 from "./ReLogin.vue?vue&type=style&index=0&id=18b1a4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1a4f2",
  null
  
)

export default component.exports